module.exports = __webpack_public_path__ + "img/keepkey.c6b6496f.svg";